// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Zz","pending":"e__z","slider":"e_0z","imageContainer":"e_1z","image":"e_2z","button":"e_3z","prevButton":"e_4z","nextButton":"e_5z","disabled":"e_6z"};